import { useSelector } from 'react-redux';
import { getPreferredEntityIds } from '../../store/selectors/user';

export default (entityField, entity) => {
  // Check if we're following related Entities Ids (ex: organization.teamIds)
  const relatedEntitiesIds = entity[entityField] || [];
  const preferredEntityIds = useSelector(state => getPreferredEntityIds(state, { entityField }));
  return Boolean(relatedEntitiesIds.find(id => preferredEntityIds.includes(id)));
};
